import DelegateConfirmation from './DelegateConfirmation';

export default DelegateConfirmation;
